// removed by extract-text-webpack-plugin
module.exports = {"arrow-container":"style__arrow-container___msjFk","arrow-container--small":"style__arrow-container--small___3Mt1D","arrow":"style__arrow___3KI0p","arrow--small":"style__arrow--small___3MgrK"};


//////////////////
// WEBPACK FOOTER
// ./components/SortArrow/style.scss
// module id = 1358
// module chunks = 0